export const TEMPLATES = [
    {
    key: "/HeroTemplates/Cover1.webp",
    value: "/pdf-bg11.jfif",
    theme: "light",
    category: "popular",
  },
  {
    key: "/HeroTemplates/NewTemp1.webp",
    value: "/pdf-bg11.jfif",
    theme: "light",
    category: "popular",
  },
  {
    key: "/HeroTemplates/Cover4.webp",
    value: "/pdf-bg9.jfif",
    theme: "light",
    category: "popular",
  },
  {
    key: "/HeroTemplates/NewTemp4.webp",
    value: "/pdf-bg9.jfif",
    theme: "light",
    category: "popular",
  },
      {
    key: "/HeroTemplates/Cover9.webp",
    value: "/bg7.jfif",
    theme: "dark",
    category: "popular",
  },
  {
    key: "/HeroTemplates/Template9.webp",
    value: "/bg7.jfif",
    theme: "dark",
    category: "popular",
  },
  {
    key: "/HeroTemplates/Cover6.webp",
    value: "/pdf-bg18.jfif",
    theme: "light",
    category: "popular",
  },
    {
    key: "/HeroTemplates/NewTemp6.webp",
    value: "/pdf-bg18.jfif",
    theme: "light",
    category: "popular",
  },
    {
    key: "/HeroTemplates/Cover8.webp",
    value: "/pdf-bg18.jfif",
    theme: "light",
    category: "popular",
  },
    {
    key: "/HeroTemplates/Template8.webp",
    value: "/pdf-bg18.jfif",
    theme: "light",
    category: "popular",
  },
    {
    key: "/HeroTemplates/Cover2.webp",
    value: "/pdf-bg10.jfif",
    theme: "light",
    category: "popular",
  },
  {
    key: "/HeroTemplates/NewTemp2.webp",
    value: "/pdf-bg10.jfif",
    theme: "light",
    category: "popular",
  },
    {
    key: "/HeroTemplates/Cover3.webp",
    value: "/pdf-bg10.jfif",
    theme: "light",
    category: "popular",
  },
  {
    key: "/HeroTemplates/NewTemp3.webp",
    value: "/pdf-bg10.jfif",
    theme: "light",
    category: "popular",
  },
  {
    key: "/HeroTemplates/Cover5.webp",
    value: "/pdf-bg18.jfif",
    theme: "light",
    category: "popular",
  },
    {
    key: "/HeroTemplates/NewTemp5.webp",
    value: "/pdf-bg18.jfif",
    theme: "light",
    category: "popular",
  },

    {
    key: "/HeroTemplates/Template3.webp",
    value: "/pdf-bg4.jpg",
    theme: "light",
    category: "popular",
  },
    {
    key: "/HeroTemplates/Template6.webp",
    value: "/pdf-bg14.jfif",
    theme: "light",
    category: "popular",
  },
    {
    key: "/HeroTemplates/Template7.webp",
    value: "/pdf-bg16.jfif",
    theme: "light",
    category: "popular",
    },
{
    key: "bg4.jfif",
    value: "/bg4.jfif",
    theme: "light",
    category: "other",
},
{
    key: "bg7.jfif",
    value: "/bg7.jfif",
    theme: "dark",
    category: "other",
},
{
    key: "bg9.jfif",
    value: "/bg9.jfif",
    theme: "light",
    category: "other",
},
{
    key: "bg12.jfif",
    value: "/bg12.jfif",
    theme: "light",
    category: "other",
},
{
    key: "bg13.jfif",
    value: "/bg13.jfif",
    theme: "light",
    category: "other",
},
{
    key: "bg14.jfif",
    value: "/bg14.jfif",
    theme: "light",
    category: "other",
},
{
    key: "bg15.jfif",
    value: "/bg15.jfif",
    theme: "light",
    category: "other",
},

];